export default {
    collection: [],
    selectedRadio: { covers: {} },
}